/**
 * @fileoverview AR-924 — Two-step indicator of the "Upload for class" modal.
 */

import { Stepper } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import type { UploadStep } from './useUploadForClass'

const STEP_INDEX: Record<UploadStep, number> = { add_files: 0, match: 1 }
/** Figma: 24px discs, 8px to the label, 40px separator with 12px on each side. */
const DISC_SIZE = 24
const LABEL_GAP = 8
const SEPARATOR_GAP = 12
const SEPARATOR_MAX_WIDTH = 40

export function UploadStepper({ step }: { step: UploadStep }) {
  const { t } = useTranslation()
  return (
    <Stepper
      active={STEP_INDEX[step]}
      size="xs"
      iconSize={DISC_SIZE}
      styles={theme => ({
        stepBody: { marginLeft: LABEL_GAP },
        separator: { marginLeft: SEPARATOR_GAP, marginRight: SEPARATOR_GAP, maxWidth: SEPARATOR_MAX_WIDTH },
        // Figma: active = filled brand disc with white number, done = green disc.
        stepIcon: {
          '&[data-progress]': {
            backgroundColor: theme.fn.primaryColor(), borderColor: theme.fn.primaryColor(), color: theme.white,
          },
          '&[data-completed]': {
            backgroundColor: theme.colors.green[7], borderColor: theme.colors.green[7], color: theme.white,
          },
        },
        stepLabel: { '[data-progress] &': { color: theme.fn.primaryColor(), fontWeight: 600 } },
      })}
    >
      <Stepper.Step label={t('task_tracker.upload_for_class.step_add_files')} />
      <Stepper.Step label={t('task_tracker.upload_for_class.step_match')} />
    </Stepper>
  )
}
